<template>
  <div class="container">
    <div class="content">
      <img src="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/register_bg.jpg" alt="" class="bg">
      <div class="logobox">
        <img src="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/register_success.png" alt="" class="register_success">
        <p class="title">恭喜您，注册成功</p>
      </div>
      <div class="box">
        <div class="box_content">
          <p class="account">账号:{{account}}</p>
          <div v-if="isWeixin" id="launch-btn"></div>
          <!-- <wx-open-launch-weapp id="launch-btn" username="gh_2301fb533b94" path=""  v-if="isWeixin">
            <script type="text/wxtag-template"><style>.btn {display: inline-block; width:100%;height:56px;background: #0079FF;text-align: center;line-height:56px;color:#fff;font-weight:600;font-size:14px; }</style> <van-button class="btn">立即去体验</van-button> </script>
          </wx-open-launch-weapp> -->
          <van-button v-else class="btn" block type="info" @click="linkmini">立即去体验</van-button>
          <div class="codebox">
            <p>长按保存企业小程序码，方便下次直接扫码进入</p>
            <img :src="codeImg" alt="" class="codeImg">
          </div>
          <div class="videobox">
            <p>如何绑定企业账号试用</p>
            <video id="my-video" class="video-js vjs-default-skin" controls preload="none" x5-playsinline=""
              webkit-playsinline="" playsinline="" poster="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/regiser_poster.jpg"
              x-webkit-airplay="allow" @click="play">
              <source src="http://1257289442.vod2.myqcloud.com/5d9018cbvodgzp1257289442/e35b9c883701925920979910316/FaQi2WqYSbcA.mp4">
            </video>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import 'video.js/dist/video-js.css'
  import videojs from 'video.js'
  import 'videojs-contrib-hls'
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  import {
    GetQtnInfo
  } from '@/api/api'
  export default {
    name: 'Index',
    components: {},
    data() {
      return {
        account: '', //账号
        codeImg: '',
        myPlayer: '', // 视频播放器实例
        isWeixin: true,
        linkUrl: '',
      }
    },
    mounted() {
      this.muser_id = this.$route.query.muser_id; //调查问卷id
      this.openlink = this.$route.query.openlink;
      this.account = localStorage.getItem('account');
      this.codeImg = localStorage.getItem('app_url');
      this.init();
      var ua = navigator.userAgent.toLowerCase()
      var isWXWork = ua.match(/wxwork/i) == 'wxwork'
      this.isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger';
      if (this.isWeixin) {
        this.linkmini();
      }
      let content =
        `<style>.btn {display: inline-block; width:100%;height:56px;background: #0079FF;text-align: center;line-height:56px;color:#fff;font-weight:600;font-size:14px; }</style> <van-button class="btn">立即去体验</van-button>`;
      let launchParams = {
        eleId: "launch-btn", // 元素id
        url: "pages/tabBar/index/index?scene=" + this.muser_id, // 跳转小程序的页面路径
        content: content // 自定义的html内容
      };
      this.wx_launch(launchParams);
    },
    methods: {
      wx_launch(info) {
        if (!this.isWeixin) {
          return
        }
        var btn = document.getElementById(info.eleId); //获取元素
        let script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = info.content // 自定义的html字符串内容
        let html =
          `<wx-open-launch-weapp style="width:100%;display:block;" username="gh_2301fb533b94" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
        // 点击按钮 正常跳转触发
        btn.addEventListener("launch", function(e) {
          console.log("success");
        });
        // 点击跳转 抛出异常
        btn.addEventListener("error", function(e) {
          console.log("fail", e.detail);
          alert(`跳转异常 - ${e.detail}`)
        });
      },
      init() {
        this.myPlayer = videojs('my-video', {
          autoplay: false, //这个说是自动播放，但是本人使用无效
          controls: true,
        }, function() {})
      },
      play() {
        this.myPlayer.play()
      },
      linkmini() {
        var that = this;

        function docReady(fn) {
          if (document.readyState === 'complete' || document.readyState === 'interactive') {
            fn()
          } else {
            document.addEventListener('DOMContentLoaded', fn);
          }
        }
        docReady(async function() {
          var isMobile = false
          var isDesktop = false
          if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
            isMobile = true
          } else {
            isDesktop = true
          }
          if (isMobile) {
            if (that.isWeixin) {
              const apiurl = 'https://xndapplet.xinnongrenxueshe.cn/v1/token_version/GetJsApiTicket'
              $.ajax({
                //请求方式
                type: 'POST',
                url: apiurl,
                dataType: 'json',
                data: {
                  url: window.location.href.split('#')[0]
                },
                success: function(res) {
                  wxSetConfig(res)
                },
                error: function(jqXHR) {}
              });

              function wxSetConfig(config) {
                wx.config({
                  debug: false,
                  appId: config.appId,
                  timestamp: config.timestamp,
                  nonceStr: config.noncestr,
                  signature: config.signature,
                  jsApiList: ['checkJsApi', 'onMenuShareTimeline'],
                  openTagList: ['wx-open-launch-weapp']
                });
              }

              var btn = document.getElementById('launch-btn');
              btn.addEventListener('launch', function(e) {
                console.log('success');
              });
              btn.addEventListener('error', function(e) {
                console.log('fail', e.detail);
              });

              wx.config({
                // debug: true, // 调试时可开启
                appId: 'wx93ed1efd36df9289', //
                timestamp: 0, // 必填，填任意数字即可
                nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
                signature: 'signature', // 必填，填任意非空字符串即可
                jsApiList: ['chooseImage'], // 必填，随意一个接口即可
                openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
              })
            } else {
              const apiurls = 'http://xndapplet.xinnongrenxueshe.net/v1/token_version/GetAppScheme'
              // https://vote.xinnongrenxueshe.com/v1/answerAct/CreateConfigWb
              /* $.ajax({
                 //请求方式
                 type: 'GET',
                 url: apiurls,
                 dataType: 'json',
                 data: {},
                 success: function(res) {
                   window.location.href = res.openlink
                 },
                 error: function(jqXHR) {}
               }); */
              window.location.href = that.openlink

              function wxSetConfig(config) {
                wx.config({
                  debug: false,
                  appId: config.appid,
                  timestamp: config.timestamp,
                  nonceStr: config.nonceStr,
                  signature: config.signature,
                  jsApiList: config.jsApiList,
                  openTagList: ['wx-open-launch-weapp']
                });
                var btn = document.getElementById('launch-btn');
                btn.addEventListener('launch', function(e) {
                  console.log('success');
                });
                btn.addEventListener('error', function(e) {
                  console.log('fail', e.detail);
                });
              }
            }
          } else if (isDesktop) {
            console.log(isDesktop)
            // 在 pc 上则给提示引导到手机端打开
            Toast.fail('请在手机端打开');
          }
        })

      },
    }
  }
</script>
<style>
  html,
  body,
  #app {
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .container {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
  }

  .content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    position: relative;
  }

  .bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .logobox {
    width: 100%;
    height: 153.5px;
    position: relative;
    top: 0;
    left: 0;
  }

  .register_success {
    width: 9.7%;
    margin-top: 4vh;
  }

  .title {
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    padding: 0;
    margin: 0;
  }

  .box {
    width: 100%;
    height: 80vh;
    background: #fff;
    border-radius: 12px;
    margin-top: -2vh;
    position: relative;
  }

  .box_content {
    padding: 40px 16px;
    font-size: 18px;
    font-weight: 500;
    color: #222222;
  }

  .account {
    margin-bottom: 28px;
    text-align: center;
  }

  .codebox {
    padding: 40px 0;
    border-top: 1px solid #E9EBEF;
    border-bottom: 1px solid #E9EBEF;
    font-size: 15px;
    color: #222222;
  }

  .codeImg {
    margin-top: 12px;
    width: 200px;
    height: 200px;
  }

  .videobox {
    padding-top: 40px;
    font-size: 18px;
    color: #222222;
    text-align: left;
  }

  .videobox p {
    padding: 0;
    margin: 0;
    margin-bottom: 12px;
  }

  #my-video {
    width: 100%;
    height: 193px;
  }

  .vjs-big-play-button {
    left: 50% !important;
    top: 50% !important;
    margin-top: -1em;
    margin-left: -1em;
  }

  .video-js .vjs-big-play-button {
    border: unset !important;
    background-color: unset !important;
  }

  .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    width: 52px;
    height: 52px;
    font-size: 30px;
    background: rgba(0, 0, 0, .5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #launch-btn {
    width: 100%;
    display: inline-block;
    margin-bottom: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/view/success.vue